<!-- The invisible copy of PreCallPreparation's initial layout only reserves its size, so the hand-over does not shift the page. -->
<template>
  <div class="relative" data-testid="pre-call-skeleton">
    <div
      class="invisible mx-auto flex w-full max-w-3xl flex-col items-center gap-6 px-4 pt-6 lg:flex-row lg:gap-10"
      aria-hidden="true"
    >
      <div class="aspect-[4/3] w-full lg:flex-[5]" />

      <div class="flex w-full flex-col gap-4 lg:flex-[4]">
        <h2 class="text-h6">&nbsp;</h2>
        <div class="flex flex-col gap-1.5">
          <span class="text-caption">&nbsp;</span>
          <VSelect disabled variant="outlined" density="compact" hide-details />
        </div>
        <div class="flex flex-col gap-1.5">
          <span class="text-caption">&nbsp;</span>
          <VSelect disabled variant="outlined" density="compact" hide-details />
          <div class="flex items-center pt-1"><VIcon icon="graphic_eq" size="18" /></div>
        </div>
        <div class="flex flex-col gap-1">
          <VBtn block disabled />
          <VBtn variant="text" block disabled />
        </div>
      </div>
    </div>

    <div class="absolute inset-0 flex items-center justify-center">
      <LoaderElement type="circular" size="large" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { VBtn, VIcon, VSelect } from 'vuetify/components'
import LoaderElement from '@/atoms/LoaderElement.vue'
</script>
